import { RootState } from '@reducers';

export const selectUsername = (state: RootState) => state.userRegistrationReducer.usernameReducer;
